import {
  ALL_SIDE_MENU_SECTIONS,
  flattenSideMenuSections,
  normalizeRouteUrl,
  resolveActiveMenuPath,
} from './side-menu.config';

/** Primary bottom-nav destinations (icon + label). */
export const MOBILE_BOTTOM_NAV_PRIMARY = [
  '/dashboard',
  '/members',
  '/loyalty-programs',
  '/rewards',
] as const;

/**
 * Immersive / CRUD / settings flows — hide the dock even if an alias maps
 * back to a primary item (e.g. /loyalty/create → /loyalty-programs).
 */
const MOBILE_BOTTOM_NAV_HIDE_PREFIXES = [
  '/loyalty/create',
  '/member-portal/studio',
  '/feedback/builder',
  '/feedback/responses',
  '/settings',
  '/mobile-settings',
  '/get-started',
  '/outlet',
  '/sign-up',
  '/otp-verification',
  '/login',
  '/signup-success',
  '/forgot-password',
] as const;

const ALL_MENU_PATHS = flattenSideMenuSections(ALL_SIDE_MENU_SECTIONS).map(
  (item) => item.path,
);

function isImmersiveMobileRoute(path: string): boolean {
  if (!path || path === '/') return true;
  for (const prefix of MOBILE_BOTTOM_NAV_HIDE_PREFIXES) {
    if (path === prefix || path.startsWith(`${prefix}/`)) return true;
  }
  // Journey builder detail (not the list under Automations)
  if (/^\/journeys\/[^/]+/.test(path)) return true;
  // Generic create / edit / new segments
  if (/\/(create|edit|new)(\/|$)/.test(path)) return true;
  return false;
}

/**
 * Bottom app bar visibility for OwnRewards admin mobile.
 *
 * Show only when the current screen belongs to a primary dock icon
 * (Home, Members, Loyalty, Rewards) — including shallow child routes that
 * alias to those icons (e.g. member profile → Members).
 *
 * Hide for More-menu destinations, settings, builders, and CRUD wizards.
 */
export function shouldShowMobileBottomNav(url: string): boolean {
  const path = normalizeRouteUrl(url || '');
  if (isImmersiveMobileRoute(path)) return false;
  const active = resolveActiveMenuPath(path, ALL_MENU_PATHS);
  return (MOBILE_BOTTOM_NAV_PRIMARY as readonly string[]).includes(active);
}
